/**
 * Formats a string for display by capitalizing the first letter and replacing underscores with spaces
 * @param {string} str - String to format (e.g., "in_progress", "draft")
 * @returns {string} Formatted string (e.g., "In progress", "Draft")
 */
export const formatLabel = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1).replace(/_/g, ' ')
}
